import React, {Component} from 'react'
import styled from "styled-components"
import {
  DESKTOP_BREAKPOINT,
} from "manager/views/components/Settlement/constants"
import AddressAutocomplete from "common/views/atoms/AddressAutocomplete/AddressAutocomplete"
import {selectSearchConfig,} from "manager/selectors/settlement_provider_search_selectors"

import {connect} from "react-redux"
import {createStructuredSelector} from "reselect"

import {
  selectAgentOpId,
  selectAssignmentTransactionHash,
  selectTransactionOpId
} from "manager/selectors/referral_selectors"
import {updateSettlementProviderSearchConfig} from "manager/redux/settlement_provider_search"

import {geocodeByAddress} from 'react-places-autocomplete'
import BackLink from "manager/views/components/Settlement/Common/BackLink"
import SettlementMaxWidth from "manager/views/components/Settlement/Common/SettlementMaxWidth"
import FooterContainer from "manager/views/components/Settlement/Common/FooterContainer"
import SettlementFormHr from "manager/views/components/Settlement/Common/SettlementFormHr"
import {SettlementForm, SettlementPadding} from "manager/views/components/Settlement/Common/SettlementCard"
import clearSvg from "manager/../images/clear-x.svg"
import {segmentEventTracker} from "common/analytics"

const UpdateAddressContainer = styled(SettlementForm)`
  display: flex;
  flex-direction: column;
  
  height: 100vh;
  margin-top: 0px;
  @media screen and ${DESKTOP_BREAKPOINT} {
      width: 936px;
      height: auto;
      margin-top: 24px;
  }
`
const BodyContainer = styled(SettlementPadding)`
  margin-bottom: 40px;
`
const Header = styled.div`
  margin-top: 24px;
  font-size: 26px;
  font-weight: bold;
  line-height: 33px;
`
const Text =  styled.div`
  margin-top: 10px;
`
const AddressInputContainer = styled.fieldset`
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  margin-bottom: 13px;
  @media screen and ${DESKTOP_BREAKPOINT} {
      width: 450px;
  }
`
const InputLabel = styled.label`
  color: #8C8C8C;
  font-size: 14px;
  font-weight: 500;
  line-height: 14px;
  margin-bottom: 7.5px;
`

const IconWrapper = styled.div`
  display: flex;
  height: 17px;
  width: 32px;
  margin-left: auto;
  margin-right: 1px;
  z-index: 0;
  margin-top: -30px;
  background-color: rgba(255,255,255,1.0);
`

const ClearIcon = styled.div`
  background-image: url(${clearSvg});
  background-size: cover;
  width: 16px;
  height: 17px;
  flex: 0 0 16px;
  cursor: pointer;
  margin-left: auto;
  margin-right: auto;
`

class UpdateAddress extends Component {

  state = {
    searchConfigFlatAddress:'',
    selectedFlatAddress: '',
    saveMode: false,
  }

  componentDidMount() {
    const {searchConfig} = this.props
    const flatAddress = [searchConfig.origin_address, searchConfig.origin_city, searchConfig.origin_state, searchConfig.origin_zipcode].filter(Boolean).join(", ");

    this.setState({
      selectedFlatAddress: flatAddress,
      searchConfigFlatAddress: flatAddress,
    })
  }

  clearInput = () => {
    this.setState({selectedFlatAddress: '', saveMode: false})
  }

  hideUpdateAddressView = () => {
    this.props.setUpdateAddressView(false)
  }

  updateSelectedAddress = (value) => {
    const {searchConfigFlatAddress} = this.state
    const inputAddress = value.trim()
    this.setState({
      selectedFlatAddress: value,
      saveMode: inputAddress && inputAddress !== searchConfigFlatAddress
    })
  }

  onError = (status) => {
      console.log('Google Maps API returned error with status: ', status)
  }

  saveAddress = () => {
    const {updateSettlementProviderSearchConfig, transaction_op_id, agent_op_id} = this.props
    const {selectedFlatAddress} = this.state

    const new_address = {}
    const number_route = {}
    geocodeByAddress(selectedFlatAddress).then(results => {
      results[0].address_components.forEach(
        part => {
          if (part.types.includes('street_number')) {
            number_route['street_number'] = part.long_name
          }
          else if (part.types.includes('route')){
            number_route['route'] = part.long_name
          }
          else if (part.types.includes('locality')){
            new_address['origin_city'] = part.long_name
          }
          else if (part.types.includes('administrative_area_level_1')){
            new_address['origin_state'] = part.short_name
          }
          else if (part.types.includes('postal_code')){
            new_address['origin_zipcode'] = part.long_name
          }
        }
      )
      updateSettlementProviderSearchConfig({
        ...new_address,
        'origin_address': [number_route['street_number'], number_route['route']].join(' ').trim()
      })

      this.hideUpdateAddressView()
      segmentEventTracker('Qualia-Provider Search Origin Address Changed', {'transaction_op_id': transaction_op_id, 'agent_op_id': agent_op_id})
    })
  }

  render() {
    const {selectedFlatAddress, saveMode} = this.state

    const addressInputProps = {
      value: selectedFlatAddress,
      onChange: value => this.updateSelectedAddress(value),
      placeholder: "Enter an Address",
    }

    const searchOptions = {
      componentRestrictions: {
        country: ['us'],
      },
    }

    const customAddressInputStyles = {
      input: {
        padding: '11.5px',
        color: '#1C1C1C',
        fontSize: '14px',
        lineHeight: '18px',
        border: '1px solid #CCCCCC',
        borderRadius: '4px',
        outline: 'none',
        paddingRight: '32px',
        backgroundClip: 'padding-box',
      }
    }

    return (
      <SettlementMaxWidth>
        <BackLink onClick={this.hideUpdateAddressView}/>
        <UpdateAddressContainer>
          <BodyContainer>
            <Header>Update Address</Header>
            <Text>Enter the full address for the property an offer was made on.</Text>
            <AddressInputContainer>
              <InputLabel>Address</InputLabel>
              <AddressAutocomplete inputProps={addressInputProps} searchOptions={searchOptions} onError={this.onError} styles={customAddressInputStyles}/>
              <IconWrapper>
                {selectedFlatAddress && selectedFlatAddress.length > 0 && <ClearIcon onClick={this.clearInput}/>}
              </IconWrapper>
            </AddressInputContainer>
          </BodyContainer>
          <SettlementFormHr/>
          <FooterContainer cancelOnClick={this.hideUpdateAddressView}
                           buttonName="Save changes"
                           disabled={!saveMode}
                           buttonOnClick={this.saveAddress}/>
        </UpdateAddressContainer>
      </SettlementMaxWidth>
    )
  }
}

const selector = createStructuredSelector({
  searchConfig: selectSearchConfig,
  hash: selectAssignmentTransactionHash,
  transaction_op_id: selectTransactionOpId,
  agent_op_id: selectAgentOpId,
})

const actions = {
  updateSettlementProviderSearchConfig
}

export default connect(selector, actions)(UpdateAddress)

